import React from 'react';
import { Siren, Phone } from 'lucide-react';
import { EMERGENCY_DATA, getCountryData } from '@/data/essentials';

const ROW_LABELS = {
  unified:               { label: 'All emergencies', emphasise: true },
  police:                { label: 'Police' },
  ambulance:             { label: 'Ambulance' },
  fire:                  { label: 'Fire' },
  tourist_helpline:      { label: 'Tourist helpline' },
  tourist_police:        { label: 'Tourist police' },
  women_helpline:        { label: 'Women helpline' },
  child_helpline:        { label: 'Child helpline' },
  non_emergency_police:  { label: 'Non-emergency police' },
  medical_advice:        { label: 'Medical advice (non-emerg.)' },
  carabinieri:           { label: 'Carabinieri' },
  mountain_rescue:       { label: 'Mountain rescue' },
  coastguard:            { label: 'Coast guard' },
  poison:                { label: 'Poison control' },
  traffic:               { label: 'Traffic accidents' },
};

export default function EmergencyCard({ countryCode, countryName }) {
  const d = getCountryData(EMERGENCY_DATA, countryCode);
  const rows = Object.keys(ROW_LABELS).filter((k) => d[k]);

  return (
    <div className="puvio-card p-5" data-testid="emergency-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-coral-deep)]">Emergency numbers</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium">{countryName || 'Local services'}</p>
        </div>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: '#FCE4E4' }}>
          <Siren className="w-6 h-6 text-[var(--puvio-coral-deep)]" />
        </div>
      </div>
      <ul className="mt-4 grid grid-cols-1 gap-2">
        {rows.map((k) => {
          const meta = ROW_LABELS[k];
          const isEmph = meta.emphasise;
          return (
            <li key={k}>
              <a
                href={`tel:${d[k]}`}
                className={`flex items-center justify-between gap-3 px-3 py-2.5 rounded-2xl border transition-colors puvio-focus ${isEmph ? 'bg-[var(--puvio-coral-deep)] text-[#0F1A13] border-transparent' : 'bg-[var(--puvio-bg-soft)] border-[var(--puvio-border)] hover:bg-[var(--puvio-bg-soft-hover)]'}`}
                data-testid={`emergency-${k}`}
              >
                <span className={`text-[12px] font-bold uppercase tracking-wide ${isEmph ? 'text-[#0F1A13]' : 'text-[var(--puvio-text-2)]'}`}>{meta.label}</span>
                <span className="flex items-center gap-2">
                  <span className={`font-extrabold text-base tracking-tight ${isEmph ? 'text-[#0F1A13]' : 'text-[#0F1A13]'}`}>{d[k]}</span>
                  <Phone className={`w-3.5 h-3.5 ${isEmph ? 'text-[#0F1A13]' : 'text-[var(--puvio-mint-deep)]'}`} />
                </span>
              </a>
            </li>
          );
        })}
      </ul>
      {d.note && <p className="text-[12px] text-[var(--puvio-text-2)] mt-3 leading-relaxed italic">{d.note}</p>}
    </div>
  );
}
